import { useEffect } from 'react';
import { useTheme } from '../../context/theme';
import { Btn } from './index';

export function ConfirmModal({ open, title, message, onConfirm, onCancel, danger }) {
  const { theme, isDark } = useTheme();

  useEffect(() => {
    const h = e => { if (e.key === 'Escape') onCancel(); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [onCancel]);

  if (!open) return null;
  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: theme.bgModal, borderRadius: 16,
          padding: 24, maxWidth: 400, width: '100%',
          boxShadow: theme.shadowLg, border: `1px solid ${theme.border}`,
          animation: 'fadeIn 0.2s ease',
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: 400, fontFamily: "'DM Sans', sans-serif", letterSpacing: '-0.01em', color: danger ? '#EF4444' : theme.text, marginBottom: 8 }}>
          {title}
        </h3>
        <p style={{ fontSize: 14, color: theme.textSecondary, lineHeight: 1.5, marginBottom: 20 }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <Btn sm onClick={onCancel}>Cancel</Btn>
          <Btn primary={!danger} danger={danger} sm onClick={onConfirm}>
            {danger ? 'Delete' : 'Confirm'}
          </Btn>
        </div>
      </div>
    </div>
  );
}
